<template>
	<div>
		<div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案采集</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>记账凭证</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- <el-divider></el-divider> -->

		<div class="container">
			<el-tabs v-model="accountingVoucherTabs" style="height: 100%;">
				<el-tab-pane label="凭证导入" name="4">
					<div class="el-upload__tip" style="color: #909399;font-size: 14px;">支持本地导入记账凭证，文件后缀类型包括：XLS/XSLX以及包含前述后缀的ZIP文件</div>

					<div  class="m-bottom-border" style="padding: 10px 0px;">
						<div style="display: flex;">
							<div style="margin-right: 15px;">
								<el-input v-model="voucherImportForm.voucherImportFileName" placeholder="请选择文件" prefix-icon="el-icon-document" clearable></el-input>
							</div>
							<div>
								<el-upload class="upload-demo" ref="voucherImport" :action="voucherImportUrl" :data="voucherImportData" :show-file-list="false" :auto-upload="false" :on-change="voucherImportFileChange" :on-success="voucherImportSuccess" :on-error="voucherImportError">
									<el-button slot="trigger" plain>选择文件</el-button>
									<el-button size="small" type="primary" style="margin-left: 10px;width: 80px;" :disabled="disabledVoucherImportBtn" @click="voucherImportClickFun">上传</el-button>
									<el-button size="small" type="primary" style="height: 32px;">
										<el-link :href='downloadTemplateUrl + "?" + token' :underline="false" style="color: #fff;font-size: 12px;" size="small">下载模板</el-link>
									</el-button>
								</el-upload>
							</div>
						</div>
					</div>
					<el-row type="flex" style="padding: 10px 0px;" justify="space-between">
						<el-col :span="2">
							<el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
						</el-col>
						<el-col :span="6"  style="text-align: right;">
							<el-input v-model="voucherImportSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
						</el-col>
					</el-row>
					<div>
						<el-table ref="accountingVoucherUploadTable" :data="accountingVoucherUploadTableData" border stripe class="table" height="530px" @row-click="(row) => clickRowByChecked('accountingVoucherUploadTable', row)">
							<el-table-column type="selection" width="55" align="center"></el-table-column>
							<el-table-column prop="batchNo" label="批次号"></el-table-column>
							<el-table-column prop="fileName" label="原文档名称"></el-table-column>
							<el-table-column prop="importWay" label="导入方式" :formatter="this.formatImportWay"></el-table-column>
							<el-table-column prop="totalCount" label="凭证总数"></el-table-column>
							<el-table-column prop="successCount" label="上传成功数">
								<template slot-scope="scope">
									<el-link type="primary" @click="viewVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
								</template>
							</el-table-column>
							<el-table-column prop="failedCount" label="上传失败数"></el-table-column>
							<el-table-column prop="message" label="失败详情">
								<template slot-scope="scope">
									<div v-if="scope.row.message && scope.row.message.length > 0">
										<el-link :href="downloadImportLogUrl + scope.row.id + '&' +  token" :underline="false" type="primary" >下载日志</el-link>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="importTime" label="上传时间"></el-table-column>
							<el-table-column prop="operator" label="操作人"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="voucherpwm.page"
								:page-size="voucherpwm.limit"
								:page-sizes="voucherpwm.limits"
								layout="total, sizes, prev, pager, next, jumper"
								:total="voucherpwm.count">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<el-dialog title="上传成功详情" :visible.sync="uploadViewDialogVisible" width="1250px" class="dialog" :close-on-click-modal="false">
			<div class="custom-dialog">
				<div style="display: flex;">
					<div style="width: 38%">
						<el-card class="box-card" style="height: 550px;">
							<div style="display: flex;padding-bottom: 10px;">
								<div style="width: 60%;float: left;">
									<el-button plain style="width: 60px;padding: 5px 15px;vertical-align: middle;" @click="upRow"><i class="el-icon-arrow-up" style="font-size: 20px;font-weight: bold;"></i></el-button>
									<el-button plain style="width: 60px;padding: 5px 15px;vertical-align: middle;" @click="downRow"><i class="el-icon-arrow-down" style="font-size: 20px;font-weight: bold;"></i></el-button>
								</div>
								<div style="width: 40%;float: right;">
									<el-input v-model="voucherHeaderSearchName" placeholder="凭证号码" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryVoucherHeaderData"></el-input>
								</div>
							</div>
							<el-table ref="voucherHeaderTable" :data="voucherHeaderTableData" height="420px" border stripe class="table" @row-click="(row) => clickRowByChecked('voucherHeaderTable', row)"  :row-class-name="tableRowClassName">
								<el-table-column type="selection" width="50"></el-table-column>
								<el-table-column prop="id" v-if="showColumn == true"></el-table-column>
								<el-table-column prop="voucherNo" label="凭证号" sortable></el-table-column>
								<el-table-column prop="voucherDate" label="记账日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
							</el-table>
							<div class="pagination">
								<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="detailRefresh()"></el-link>
								<el-pagination
									@size-change="handleSizeVoucherDetailChange"
									@current-change="handleCurrentVoucherDetailChange"
									:current-page="pwm.page"
									:page-size="pwm.limit"
									:page-sizes="pwm.limits"
									layout="total, sizes, prev, pager, next, jumper"
									:total="pwm.count">
								</el-pagination>
							</div>
						</el-card>
					</div>
					<div style="width: 62%">
						<el-card class="box-card" style="height: 550px;margin-left:5px;">
							<div style="text-align: center;height: 480px;">
								<accvoucher ref="accvoucher" v-bind:accvoucherId="accvoucherId" style="width: 98%;"></accvoucher>
							</div>
						</el-card>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
export default {
	name: 'basetable',
	data() {
		return {
			voucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			pwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			accountingVoucherTabs: '4', // 默认选中tab页
			voucherImportFormatArr: ['xlsx', 'xls', 'zip'],
			voucherImportForm: {
				voucherImportFileName: ''
			},
			disabledVoucherImportBtn: false,
			voucherImportUrl: this.baseURL + "/archival/uploadOriginalVoucherFile",
			voucherImportData: {
				token: '',
				type: '',
				companyId: ''
			},
			downloadTemplateUrl: this.baseURL + "/archival/voucher/downloadTemplate",
			downloadImportLogUrl: this.baseURL + '/archival/voucher/downloadImportLog?id=',
			token: "&token=" + localStorage.getItem('token'),
			voucherImportSearchName: '',
			accountingVoucherUploadTableData: [],
			uploadViewDialogVisible: false,
			accvoucherId: '',	//	记账凭证ID
			showColumn: false,
			voucherHeaderSearchName: '',
			batchNo: '',
			voucherHeaderTableData:  [],
			currentRowIndex: ''	//	当前 index
		};
	},
	created: function() {
		this.getAccountingVoucherUploadData();
	},
	methods: {
		refresh() {
			this.getAccountingVoucherUploadData();
		},
		detailRefresh() {
			this.getVoucherHeaderDataByBatchNo(this.batchNo);
		},
		handleSizeChange(val) {
			this.voucherpwm.limit = val;
			this.getAccountingVoucherUploadData();
		},
		handleCurrentChange(val) {
			this.voucherpwm.page = val;
			this.getAccountingVoucherUploadData();
		},
		handleSizeVoucherDetailChange(val) {
			this.pwm.limit = val;
			this.getVoucherHeaderDataByBatchNo(this.batchNo);
		},
		handleCurrentVoucherDetailChange(val) {
			this.pwm.page = val;
			this.getVoucherHeaderDataByBatchNo(this.batchNo);
		},
		clickRowByChecked(refTableName, row) {
			if(refTableName == 'voucherHeaderTable') {
				this.$refs.voucherHeaderTable.clearSelection();
				this.currentRowIndex = row.rowIndex;

				//	切换图片
				this.showVoucherFile(row);
			}
			this.$refs[refTableName].toggleRowSelection(row);
		},
		tableRowClassName({row, rowIndex}) {
			row.rowIndex = rowIndex;
		},
		upRow() {	//	dialog 查看凭证信息 table 行上翻
			let checkRows = this.$refs.voucherHeaderTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行上翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			if(this.pwm.page == 1 && index == 0) {
				this.$message.error('当前已为第一个文件，无法上翻！');
				return;
			}
			let upData = [];
			if(index != 0) { //	非第一页第一条数据
				upData = this.voucherHeaderTableData[index - 1];
				this.clickRowByChecked('voucherHeaderTable', upData);
			} else {
				this.handleCurrentVoucherDetailChange(this.pwm.page - 1);
				this.getVoucherHeaderDataByBatchNo(this.batchNo).then((val) => {
					upData = this.voucherHeaderTableData[this.voucherHeaderTableData.length - 1];
					this.clickRowByChecked('voucherHeaderTable', upData);
				})
			}
			//	翻页查看凭证文件
			this.showVoucherFile(upData);
		},
		downRow() {	//	row 下翻
			let checkRows = this.$refs.voucherHeaderTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行下翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			//	计算pageCount 分页总数
			let pageCount = Math.ceil(this.pwm.count / this.pwm.limit);
			if(this.pwm.page == pageCount && index == this.voucherHeaderTableData.length - 1) {
				this.$message.error('当前已为最后一个文件，无法下翻！');
				return;
			} 
			let downData = [];
			if(index != this.voucherHeaderTableData.length - 1) {	//	非当前页最后一条数据
				downData = this.voucherHeaderTableData[index + 1];
				this.clickRowByChecked('voucherHeaderTable', downData);
			} else {
				this.handleCurrentVoucherDetailChange(this.pwm.page + 1);
				this.getVoucherHeaderDataByBatchNo(this.batchNo).then((val) => {
					downData = this.voucherHeaderTableData[0];
					this.clickRowByChecked('voucherHeaderTable', downData);
				});
			}
			//	翻页查看凭证文件
			this.showVoucherFile(downData);
		},
		async getAccountingVoucherUploadData() {	//	获取记账凭证上传记录数据
			let pwm = this.voucherpwm;
			pwm.search = { 'type': this.accountingVoucherTabs };
			pwm.likeSearch = this.voucherImportSearchName;
			await fetchPost('/archival/getOriginalVoucherImportList', pwm).then(res => {
				this.accountingVoucherUploadTableData = res.data.data;
				this.voucherpwm.count = res.data.count;

				this.clearUploadFileName();
			}, error => {
				this.$message.error('加载上传信息失败：' + error);
			});
		},
		async getVoucherHeaderDataByBatchNo(batchNo) {	//	获取当前上传批次的凭证头数据
			this.pwm.likeSearch = this.voucherHeaderSearchName;
			this.pwm.search = { "batchNo": batchNo };
			await fetchPost('/archival/voucher/getAccountVoucherHeaderListByBatchNo', this.pwm).then(res => {
				this.voucherHeaderTableData = res.data.data;
				this.pwm.count = res.data.count;
			}, error => {
				this.$message.error('加载当前批次记账凭证信息失败：' + error);
			});
		},
		advanceQueryUploadData() {	//	高级查询
			this.getAccountingVoucherUploadData();
		},
		advanceQueryVoucherHeaderData() {	//	dialog 高级查询
			this.getVoucherHeaderDataByBatchNo(this.batchNo);
		},
		voucherImportFileChange(file, fileList) {	//	凭证导入 - change事件
			this.voucherImportForm.voucherImportFileName = file.name;

			//	选择文件前清空之前上传的文件
			this.clearUploadFile(file, fileList);

			//	校验文件上传格式
			this.validUploadFileFormat(file).then((validFlag) => {
				if(!validFlag) {
					this.disabledVoucherImportBtn = true;
				} else {
					this.disabledVoucherImportBtn = false;
				}
			});
		},
		async clearUploadFile(file, fileList) {	//	清空上传文件
			let newFileList = fileList.filter(item => {
				if(item.uid == file.uid) {
					return true;
				} else {
					return false;
				}
			});
			this.$refs.voucherImport.uploadFiles = newFileList;
		},
		async clearUploadFileName() {
			this.voucherImportForm.voucherImportFileName = "";
			this.$refs.voucherImport.clearFiles();
		},
		async validUploadFileFormat(file) {	//	校验文件格式
			let fileType = file.name.substr(file.name.lastIndexOf('.') + 1);
			if(!this.voucherImportFormatArr.includes(fileType.toLowerCase())) {
				this.$message.error('当前格式不支持，请上传XLS、XLSX以及包含前述后缀的文件！');
				return false;
			}
			return true;
		},
		voucherImportClickFun() {	//	凭证导入
			this.voucherImportData.type = this.accountingVoucherTabs;
			this.voucherImportData.token = localStorage.getItem('token');
			if(!this.voucherImportForm.voucherImportFileName || !this.$refs.voucherImport.uploadFiles || this.$refs.voucherImport.uploadFiles.length == 0) {
				this.$message.error('请选择需要上传的文件！');
				return;
			}
			this.$refs.voucherImport.submit();
		},
		voucherImportSuccess(res, file, fileList) {
			if(res.success) {
				this.$message.success('正在上传，请刷新查看上传结果！');
				this.getAccountingVoucherUploadData();
			} else {
				this.$message.error('文件上传失败：' + res.message);
			}
		},
		voucherImportError(error, file, fileList) {
			this.$message.error('文件上传失败：' + error);
		},
		deleteUploadDataClickFun() {	//	删除凭证上传数据
			let idList = [];
			let checkRows = this.$refs.accountingVoucherUploadTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要删除的上传信息！');
				return;
			}
			checkRows.forEach(row => {
				idList.push(row.id);	
			});
			let ids = idList.join(",");
			this.$confirm('是否删除选中的上传信息？', '提示', { type: 'warning' }).then(res => {
				fetchPost('/archival/deleteAccountVoucherUploadData', ids).then(res => {
					if(res.data.success) {
						this.$message.success('删除成功！');
						//	reload table data
						this.getAccountingVoucherUploadData();
					} else {
						this.$message.error('删除失败：' + res.data.message);
					}
				}, error => {
					this.$message.error('删除失败：' + error);
				});
			});
		},
		viewVoucherUploadDetail(row) {
			if(!row || row.successCount == 0) {
				return;
			}
			this.batchNo = row.batchNo;
			this.voucherHeaderSearchName = "";
			this.uploadViewDialogVisible = true;
			this.getVoucherHeaderDataByBatchNo(row.batchNo).then((val) => {
				if(this.voucherHeaderTableData && this.voucherHeaderTableData.length > 0) {
					let firstOriVoucherData = this.voucherHeaderTableData[0];
					//	默认选中第一条数据
					this.clickRowByChecked('voucherHeaderTable', firstOriVoucherData);
				}
			});
		},
		showVoucherFile(voucherData) {	//	显示凭证文件
			this.$refs.accvoucher.getAccountVoucherDataById(voucherData.id);
		},
	}
};
</script>

<style scoped>
	.el-dialog {
		margin: 0 auto !important;
	}
	.el-dialog__header {
		padding: 0 !important;
	}

	.el-dialog__wrapper {
		display: flex ;
		align-items: center ;
		
	}
	/* /deep/ .el-upload--text {
		width: 85px;
		height: 35px;
	} */

	.item {
		display: flex;
		align-items: center;
	}
	.fle1 {
		display: flex;
	}

	/* /deep/ .el-form-item--small {
		margin-left: 20px;
	}
	/deep/.el-input {
		width: 150px;
	} */
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}
	.table {
		width: 100%;
		font-size: 14px;
	}
	.red {
		color: #ff0000;
	}
	.mr10 {
		margin-right: 10px;
	}
	.container /deep/.el-tabs__header {
		margin-bottom: 8px;
	}
	/* upload 文件上传组件 */
	.container /deep/ .el-upload {
		display: inline;
	}
	.container /deep/ .el-upload--text {
		border: none !important;
		border-radius: 0px !important;
		width: 80px;
		height: 32px;
	}
	/deep/ .el-card__body {
		padding: 20px 10px 20px 20px ;
	}
	/deep/ .el-dialog__body {
		padding: 30px 10px;
	}
</style>
